import React, { useState } from 'react';
import '../../../App.css';
import { db, contact_infos_col_name } from '../../../firebase';
import { doc, setDoc} from 'firebase/firestore';
import { log } from 'firebase/firestore/pipelines';

export const ManageContactsUs = () => {
    const contactsID = 'contacts-id';
    const [contactInfos, setContactInfos] = useState({
        email: '',
        phone: '',
        address: '',
        tiktok: '',
        instagram: '',
        whatsapp: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setContactInfos((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        log(contactInfos);
        setSuccessMessage("");
        try {
            await setDoc(doc(db, contact_infos_col_name, contactsID), contactInfos);
            setSuccessMessage("Contact infos updated successfully");
            setError(null);
        } catch (error) {
            setError("Failed to update contact infos, Try again later");
            console.log(error);
            
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <section className="admin-section fade-in">
            <h2>Update Contact Infos</h2>
            <form className="admin-form" onSubmit={handleSubmit}>
                <div className="add-products-form-grid">
                    <div className="form-group">
                        <label>Email Address</label>
                        <input type="email" name="email" value={contactInfos.email} onChange={handleChange} placeholder="contact@example.com" required/>
                    </div>
                    <div className="form-group">
                        <label>Phone Number</label>
                        <input type="tel" name="phone" value={contactInfos.phone} onChange={handleChange} placeholder="+255 456 7890" required/>
                    </div>
                    <div className="form-group">
                        <label>Address</label>
                        <input type="text" name="address" value={contactInfos.address} onChange={handleChange} placeholder="Street, City, Country" required/>
                    </div>
                </div>
                <div className="form-group form-group--full">
                    <label>Social Media Links</label>
                    <input type="text" name="tiktok" value={contactInfos.tiktok} onChange={handleChange} placeholder="TikTok URL" className="mb-2" required/>
                    <input type="text" name="instagram" value={contactInfos.instagram} onChange={handleChange} placeholder="Instagram URL" className="mb-2" required/>
                    <input type="text" name="whatsapp" value={contactInfos.whatsapp} onChange={handleChange} placeholder="WhatsApp URL" required/>
                </div>
                {successMessage && <p className="success-message" style={{ color: 'green' }}>{successMessage}</p>}
                {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Info'}
                </button>
            </form>
        </section>
    );
};
